import { useState, useEffect } from 'react';

import {
  invalidateGetOrderDetailById,
  useGetOrderDetailById,
} from 'shared/hooks';
import {
  closeOrderDetailDialog,
  getPartnerId,
  logAnalyticSFMainBtn,
  sfCancelOrderModalObserver,
  sfOpenFlowExternalObserver,
} from 'features/order/substitution-flow/infra';

import type { OrderId, SubstitutionFlowStatus } from 'shared/domain';

export function useSubstitutionFlow({ orderId }: Props) {
  const [open, setOpen] = useState(false);
  const [fromChatBtn, setFromChatBtn] = useState(false);

  const { data: order, isSuccess: hasOrder } = useGetOrderDetailById(orderId);

  const isRendered = hasOrder && order.statusAuxiliary === 'in_store';
  const cancelOpts: SubstitutionFlowStatus[] = ['another', 'timeout', 'chat'];

  const showStartSFBtn =
    hasOrder &&
    order.substitutionFlowState === null &&
    (order.status === 'new_order' || order.status === 'cooking');
  const showCancelBtn =
    hasOrder &&
    order.substitutionFlowState !== null &&
    cancelOpts.includes(order.substitutionFlowState.status);

  const handleOpen = () => {
    logAnalyticSFMainBtn({
      partnerId: getPartnerId(),
      storeId: order.products[0].storeId,
      orderId: order.id,
      orderStatus: order.status,
    });
    setOpen(true);
  };

  const handleBack = () => setOpen(false);

  const handleCancelOrder = () => {
    sfCancelOrderModalObserver().dispatch(order);
    setTimeout(() => {
      invalidateGetOrderDetailById(orderId);
      closeOrderDetailDialog();
    }, 50);
  };

  useEffect(() => {
    const openFlowObserver = sfOpenFlowExternalObserver();
    openFlowObserver.add(({ detail }) => {
      if (Boolean(detail.orderId) && hasOrder) {
        setFromChatBtn(true);
        setOpen(true);
      }
    });
    return () => {
      openFlowObserver.remove();
    };
  }, [orderId, hasOrder]);

  return {
    isRendered,
    showStartSFBtn,
    showCancelBtn,
    open,
    fromChatBtn,
    handleOpen,
    handleBack,
    handleClose: closeOrderDetailDialog,
    handleCancelOrder,
  };
}

interface Props {
  orderId: OrderId;
}
